import { IPreloadedState } from 'shared/types/redux';

export const selectAllFiltersModalOpened = (state: IPreloadedState) => state.modals.allFiltersModalOpened;
